export const RADIANT_AVATAR_ACCEPT = "image/jpeg,image/png,image/webp";
export const RADIANT_AVATAR_MAX_SIDE = 240;
export const RADIANT_AVATAR_WEBP_QUALITY = 0.82;

function loadImageFromFile(file) {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(image);
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Impossible de lire l'image sélectionnée."));
    };

    image.src = objectUrl;
  });
}

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Impossible de convertir l'image."));
    reader.readAsDataURL(blob);
  });
}

function canvasToBlob(canvas, mimeType, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) resolve(blob);
        else reject(new Error("Conversion de l'image impossible."));
      },
      mimeType,
      quality
    );
  });
}

export async function prepareRadiantPlayerAvatar(file) {
  if (!file || !file.type.startsWith("image/")) {
    throw new Error("Veuillez sélectionner une image.");
  }

  if (!RADIANT_AVATAR_ACCEPT.split(",").includes(file.type)) {
    throw new Error("Formats acceptés : JPEG, PNG ou WebP.");
  }

  const image = await loadImageFromFile(file);
  const longestSide = Math.max(image.width, image.height, 1);
  const scale = Math.min(1, RADIANT_AVATAR_MAX_SIDE / longestSide);
  const width = Math.max(1, Math.round(image.width * scale));
  const height = Math.max(1, Math.round(image.height * scale));

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext("2d");
  if (!context) {
    throw new Error("Conversion de l'image impossible.");
  }

  context.drawImage(image, 0, 0, width, height);

  let blob;
  try {
    blob = await canvasToBlob(canvas, "image/webp", RADIANT_AVATAR_WEBP_QUALITY);
  } catch {
    blob = await canvasToBlob(canvas, "image/jpeg", RADIANT_AVATAR_WEBP_QUALITY);
  }

  return blobToDataUrl(blob);
}
